import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { getIn } from "formik";
import { FormHelperText, Box } from "@material-ui/core";
import { DployFormControl } from "./DployTextField";
import isArray from "lodash/isArray";
import { Dropzone } from "./Dropzone";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { identityRecordOfFieldEditorOptions } from "./utils";
export function useFieldToDropzone(props) {
    const { field, form, label, disabled, error, helperText, accept, minSize, maxSize, preventDropOnDocument, noClick, noKeyboard, noDrag, noDragEventsBubbling, onDrop, onDropAccepted, onDropRejected, getFilesFromEvent, onFileDialogCancel, onSelect, selected, imgBackground, multiple, onDragEnter, onDragOver, onDragLeave, children, placeholder, variant, previewImages, ...rest } = props;
    const dropZoneOptions = {
        accept,
        minSize,
        maxSize,
        preventDropOnDocument,
        noClick,
        noKeyboard,
        noDrag,
        noDragEventsBubbling,
        onDrop,
        onDropAccepted,
        onDropRejected,
        getFilesFromEvent,
        onFileDialogCancel,
        multiple,
        onDragEnter,
        onDragOver,
        onDragLeave
    };
    const { name, value: files } = field;
    const { touched, errors, isSubmitting } = form;
    let fieldError = getIn(errors, name);
    if (fieldError && isArray(fieldError)) {
        fieldError = (_jsx("ul", { children: fieldError.map((m, i) => (_jsx("li", { children: m }, i))) }));
    }
    const showError = getIn(touched, name) && !!fieldError;
    const onChange = useCallback(files => {
        form.setFieldValue(field.name, files, false);
    }, [field.name, form]);
    const onError = useCallback(messages => {
        form.setFieldTouched(field.name, true, false);
        form.setFieldError(field.name, messages);
    }, [form, field.name]);
    return {
        formControlProps: {
            error: showError,
            disabled: isSubmitting || props.disabled,
            ...rest
        },
        helperText: showError ? fieldError : helperText,
        dropzoneProps: {
            ...dropZoneOptions,
            onError,
            files,
            onChange,
            disabled: isSubmitting || props.disabled,
            onSelect,
            selected,
            imgBackground,
            placeholder,
            label,
            variant,
            previewImages,
            children
        }
    };
}
export function DropzoneField(props) {
    const { formControlProps, helperText, dropzoneProps } = useFieldToDropzone(props);
    return (_jsxs(DployFormControl, { ...formControlProps, children: [_jsx(Dropzone, { ...dropzoneProps }), helperText && (_jsx(FormHelperText, { component: "div", children: helperText }))] }));
}
export function PreviewDropzoneField(props) {
    const { formControlProps, helperText, dropzoneProps } = useFieldToDropzone(props);
    return (_jsxs(DployFormControl, { ...formControlProps, children: [_jsx(Dropzone, { ...dropzoneProps, previewImages: true, label: _jsxs(Box, { display: "flex", flexDirection: "column", p: 2, alignItems: "center", justifyContent: "center", children: [_jsx(CloudUploadIcon, {}), dropzoneProps.label] }) }), helperText && (_jsx(FormHelperText, { component: "div", children: helperText }))] }));
}
export function ButtonDropzoneField(props) {
    const { formControlProps, helperText, dropzoneProps } = useFieldToDropzone(props);
    return (_jsxs(DployFormControl, { ...formControlProps, children: [_jsx(Dropzone, { ...dropzoneProps, variant: dropzoneProps.variant ?? "button" }), helperText && (_jsx(FormHelperText, { component: "div", children: helperText }))] }));
}
export const EditorDropzoneFields = identityRecordOfFieldEditorOptions({
    PreviewDropzoneField: {},
    ButtonDropzoneField: {},
    DropzoneField: {}
});
//# sourceMappingURL=DropzoneFields.js.map